import {
  SET_IDS,
  SET_DEFINECUS,
  SET_CRM_LIST,
  SET_ACTIVE_CRM_KEY,
  SET_ACTIVE_CRM_HEADER,
  SET_ACTIVE_CRM_DATA,
  SET_CRM_STATE_TO_INITIAL,
  SET_CRM_LOOKALIKE,
  SET_CRM_AUDIENCE_SIZE,
  SET_CRM_DATASET,
  RESET_ERROR,
  RESET_CRM_ID,
  SAVE_CRM_DATA,
  SET_CRM_HEADERS,
  SET_CRM_TEMPLATE_USE
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case SET_IDS: {
      return {
        ...state,
        ids: action.payload,
      };
    }
    case SET_DEFINECUS: {
      return {
        ...state,
        defineCus: { names: action.payload },
      };
    }
    case SET_CRM_LIST: {
      return {
        ...state,
        crmList: action.payload,
      };
    }

    case SET_ACTIVE_CRM_KEY: {
      return {
        ...state,
        crmDataStoreKey: action.payload,
      };
    }

    case SET_ACTIVE_CRM_HEADER: {
      return {
        ...state,
        headers: action.payload,
      };
    }

    case SET_ACTIVE_CRM_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }

    case SET_CRM_STATE_TO_INITIAL: {
      return {
        ...action.payload,
      };
    }

    case SET_CRM_LOOKALIKE: {
      return {
        ...state,
        lookalike: action.payload,
      };
    }

    case SET_CRM_AUDIENCE_SIZE: {
      return {
        ...state,
        audienceSize: action.payload,
      };
    }

    case SET_CRM_DATASET: {
      return {
        ...state,
        dataset: action.payload,
      };
    }

    case RESET_ERROR: {
      return {
        ...state,
        errorText: '',
        error: false
      }
    }
    case RESET_CRM_ID: {
      return {
        ...state,
        ids: null
      }
    }

    case SAVE_CRM_DATA: {
      return {
        ...state,
        saveCRMData: action.payload
      }
    }

    case SET_CRM_HEADERS: {
      return {
        ...state,
        crmDataHeaders: action.payload
      }
    }

    case SET_CRM_TEMPLATE_USE: {
      return {
        ...state,
        crmTemplate: action.payload
      }
    }

    default:
      return state;
  }
};
